import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { routes } from 'utils/routeHelper';
import ScrollToTop from 'components/common/ScrollToTop';
import LessonIframe from './LessonIframe';
import Main from './Main';
import './styles.scss';

const Documents = () => {
  return (
    <div styleName="wrapper" data-testid="document">
      <ScrollToTop>
        <Switch>
          <Route path={routes.DOCUMENTS_DASHBOARD} component={Main} />
          <Route
            path={[
              routes.DOCUMENTS_LESSON_SUMMARIES,
              routes.DOCUMENTS_LESSON_CONTENT,
            ]}
            component={LessonIframe}
          />
        </Switch>
      </ScrollToTop>
    </div>
  );
};

export default Documents;
